module.exports = __webpack_public_path__ + "media/images/fav-e989416347731e1c98a14346f560bff9.png";